import { Map } from '../../assets/scripts/global/03-map';
import pegasus from '../../assets/scripts/global/01-pegasus';

window.GoogleMap = () => {
    return {
        map: null,
        mapData: {},
        regionCenters: {},
        officeLocations: [],
        defaultZoom: 2,
        activeRegion: 'All',

        init() {
            const mapElement = this.$root.querySelector('.Map__Container');
            console.log("Map Element:", mapElement);
            this.mapData = mapElement.dataset.pegasusMap ? JSON.parse(mapElement.dataset.pegasusMap) : {};
            console.log("Map Data:", this.mapData);
            this.regionCenters = this.mapData.regionCenters || {};
            this.officeLocations = this.mapData.officeLocations || [];
            this.defaultZoom = this.mapData.defaultZoom || 2;
            this.map = new Map(this.$refs.map, {center: this.getSearchCenter(), zoom: this.defaultZoom});
            this.map.setMarkers(this.mapData.addresses, true);
        },

        /**
         * Returns latest selected geolocation from search form
         * @returns {{lng: number, lat: number}}
         */
        getSearchCenter() {
            return {
                lat: parseFloat(this.mapData.mapCenterLat),
                lng: parseFloat(this.mapData.mapCenterLng)
            }
        },

        updateMapForRegion(region) {
            const regionKey = region.toLowerCase();
            const regionData = this.regionCenters[regionKey];

            const center = (region.toLowerCase() === 'all' || !regionData)
                ? this.getSearchCenter()
                : { lat: parseFloat(regionData.lat), lng: parseFloat(regionData.lng) };

            const zoom = regionData?.zoom || this.defaultZoom;

            google.maps.event.trigger(this.mapRef, 'resize');

            this.activeRegion = region;

            this.map.setMyCenter(center).then(() => {
                this.map.setZoom(zoom);
            });

            pegasus.scroll(this.$root.querySelector('.Google-Map__Right'), -150);

        }
    }
}
